export const TopBar = {
    SET_ROLE: "topbar.set_role",
    SET_VIEW: "topbar.set_view",
};
